import { Box, Skeleton, Stack } from "@mui/material";

const FeedPostSkeleton = () => {
  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: 600,
        mx: "auto",
        p: 2,
        borderRadius: 2,
        boxShadow: 2,
        mb: 3,
        border: "1px solid #e0e0e0",
      }}
    >
      {/* User Info */}
      <Stack direction="row" spacing={2} alignItems="center" mb={1}>
        <Skeleton variant="circular" width={40} height={40} />
        <Box>
          <Skeleton variant="text" width={100} height={20} />
          <Skeleton variant="text" width={60} height={15} />
        </Box>
      </Stack>

      {/* Post Description */}
      <Skeleton variant="text" width="40%" height={20} sx={{ mb: 1 }} />

      {/* Image */}
      <Skeleton
        variant="rectangular"
        width="100%"
        height={300}
        sx={{ borderRadius: 2 }}
      />

      {/* Reactions */}
      <Box sx={{ display: "flex", gap: 2, mt: 2 }}>
        <Skeleton variant="circular" width={24} height={24} />
        <Skeleton variant="circular" width={24} height={24} />
      </Box>
    </Box>
  );
};

export default FeedPostSkeleton;
